<template>
  <div>
    <div class="d-flex justify-center">
      <div class="_temp_list">
        <div class="pa-1">
          <v-card class="rounded_max mb-2" elevation="1">
            <div class="d-flex justify-space-between pa-2">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" @click="$router.go(-1)" icon
                    ><v-icon>mdi-reply</v-icon></v-btn
                  >
                </template>
                <span>Back</span>
              </v-tooltip>
              <h3 class="mb-2">Mentor Area</h3>
              <v-icon></v-icon>
            </div>
            <v-tabs centered slider-size="4" v-model="tab" color="#62c3f8">
              <!-- <v-tab
                v-if="role == 'VENDOR' && permissions.includes('MENTOR')"
                class="text-capitalize"
              >
                <b>Review</b>
              </v-tab> -->
              <v-tab
                v-if="
                  role == 'SUPERADMIN' ||
                  permissions.includes('LD') ||
                  permissions.includes('UPCM') ||
                  permissions.includes('ELSN')
                "
                class="text-capitalize"
              >
                <b>Mentor List</b>
              </v-tab>
              <v-tab
                class="text-capitalize"
                v-if="
                  role == 'SCHOLAR' ||
                  (permissions.includes('MENTOR') && role == 'VENDOR')
                "
              >
                <b>Schedule</b>
              </v-tab>
              <v-tab
                v-if="
                  (role == 'VENDOR' && permissions.includes('MENTOR')) ||
                  role == 'SCHOLAR' ||
                  permissions.includes('LD') ||
                  permissions.includes('UPCM') ||
                  permissions.includes('ELSN')
                "
                class="text-capitalize"
              >
                <b>Forum</b>
              </v-tab>
            </v-tabs>
          </v-card>
        </div>
        <v-tabs-items v-model="tab" style="background: transparent">
          <!-- <v-tab-item
            class="pa-1"
            v-if="role == 'VENDOR' && permissions.includes('MENTOR')"
          >
            <v-card class="rounded_max" elevation="1" style="overflow: hidden">
              <div class="strip_y" style="background: #62c3f8"></div>
              <list-member-scholar-mentor
                class="ma-3"
                color="#62c3f8"
                :idCourse="this.$route.params.idCourse"
                viewType="facilitator"
              />
            </v-card>
          </v-tab-item> -->
          <v-tab-item
            class="pa-1"
            v-if="
              role == 'SUPERADMIN' ||
              permissions.includes('LD') ||
              permissions.includes('UPCM') ||
              permissions.includes('ELSN')
            "
          >
            <v-card class="rounded_max" elevation="1" style="overflow: hidden">
              <div class="strip_y" style="background: #62c3f8"></div>
              <list-mentor
                class="ma-3"
                :color="'#62c3f8'"
                :idCourse="this.$route.params.idCourse"
              />
            </v-card>
          </v-tab-item>
          <v-tab-item
            v-if="
              role == 'SCHOLAR' ||
              (permissions.includes('MENTOR') && role == 'VENDOR')
            "
          >
            <div class="rounded_max" style="overflow: hidden">
              <list-schedule-scholar-mentor
                v-if="role == 'SCHOLAR'"
                :courseName="courseName"
              />
              <list-schedule-mentor
                v-if="role == 'SUPERADMIN' || permissions.includes('LD')"
                :courseName="courseName"
                :viewType="'readOnly'"
              />
              <list-schedule-mentor
                v-if="
                  role != 'SUPERADMIN' &&
                  !permissions.includes('LD') &&
                  permissions.includes('MENTOR')
                "
                :courseName="courseName"
              />
            </div>
          </v-tab-item>
          <v-tab-item
            v-if="
              (role == 'VENDOR' && permissions.includes('MENTOR')) ||
              role == 'SCHOLAR' ||
              permissions.includes('LD') ||
              permissions.includes('UPCM') ||
              permissions.includes('ELSN')
            "
            class="pa-1"
          >
            <list-forum-mentor
              :color="'#62c3f8'"
              :idCourse="this.$route.params.idCourse"
            />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
  </div>
</template>

<script>
import mentorReview from "../mentor/mentorReview.vue";
import listMentor from "../memberScholarCourse/mentor/listMentor.vue";
import listMemberScholarMentor from "../memberScholarCourse/mentor/listMemberScholarMentor.vue";
import ListForumMentor from "./forum/listForumMentor.vue";
import ListScheduleMentor from "./schedule/listScheduleMentor.vue";
import { mapState } from "vuex";
import ListScheduleScholarMentor from "./schedule/listScheduleScholarM.vue";
export default {
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
  name: "mentorDetail",
  components: {
    mentorReview,
    listMentor,
    listMemberScholarMentor,
    ListForumMentor,
    ListScheduleMentor,
    ListScheduleScholarMentor,
  },
  data() {
    return {
      tab: null,
      courseName: "",
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let data = {
        path: `manage/course?filter[id]=${this.$route.params.idCourse}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.courseName = data.data[0].title;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
  },
};
</script>

<style>
.strip_y {
  padding: 3px;
  height: 10px;
  width: 100%;
  border-radius: 0 !important;
}
.v-tabs-slider {
  border-radius: 3px 3px 0 0 !important;
}
</style>
